var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-nav"},_vm._l((_vm.navList),function(item,index){return _c('ModelNavButton',{key:index,attrs:{"label":item.label,"idle":item.icons.idle,"pressed":item.icons.pressed,"active":_vm.selectedItem === item},on:{"click":function($event){return _vm.onButtonClicked(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }